import PropTypes from 'prop-types';
import styled from 'styled-components';

const List = styled.ul`
  position: absolute;
  z-index: 3;
  top: 50px;
  left: 0;
  right: 0;
  margin: 0;
  overflow: hidden;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 0 0 40px;
  background: #fff
    url('https://developers.google.com/places/documentation/images/powered-by-google-on-white.png')
    no-repeat bottom 10px left 10px;
`;

const ListItem = styled.li`
  position: relative;
  padding: 15px 10px 10px;
  border-bottom: 1px solid #ccc;
  color: #c90404;
  cursor: not-allowed;
  background-color: white;
  list-style: none;
  font-size: 14px;
  font-style: italic;
  outline: 0;
`;

const Message = styled.span`
  display: block;
  white-space: overflow;
  text-overflow: ellipsis;
  margin-bottom: 5px;
`;

export default function WrongLocationInputMessage(props) {
  return (
    <List className={'dc-wrong-location-input-message-list'} role={'listbox'}>
      <ListItem className={'dc-wrong-location-input-message-list__item'} key={0}>
        <Message className={'dc-wrong-location-input-message-list__item__text'}>
          {props.message}
        </Message>
      </ListItem>
    </List>
  );
}

WrongLocationInputMessage.displayName = 'WrongLocationInputMessage';

WrongLocationInputMessage.propTypes = {
  message: PropTypes.string.isRequired
};
